
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Spedizione } from '@/models';
import ItemListRigaSpedizione from "./ItemListRigaSpedizione.vue";

@Component({
    components: { ItemListRigaSpedizione }
})
export default class SpedizioniList extends Vue {
    @Prop() public spedizioni!: Spedizione[];
}
